import Cookies from "js-cookie";
import API from "../../api/API";
import { CurrentEnvPrefix } from "config/urlprefix.js";

var api = new API();

var goods = [];
var store = [];

let sourec = {
  appversion: 1.0,
  fromWhere: { h5: "h5", ios: "iosapp", android: "androidapp" },
  isFromApp: false, //	是否来自app
  sfrom: "",
  key: "",
  isIos: "",
  isAndroid: "",
  plapi: CurrentEnvPrefix.plapi, // 'http://api-pl-mobile.zhaojiafang.com/api',
  extapi: CurrentEnvPrefix.extapi, // 'http://extapi.zhaojiafang.com/v1',
  productionUrl: CurrentEnvPrefix.main, // 'http://www.zhaojiafang.com',//生产环境链接跳转的域名
  productionDetailUrl: CurrentEnvPrefix.productionDetailUrl, // 'http://detail.zhaojiafang.com',//生产环境链接跳转的域名(带detail的)
  qiniu: CurrentEnvPrefix.qiniu
};
let _barHeight = window.control ? window.control.getStateBarHeight() : 0;

let _saveGoodsword = function(goodsword) {
  localStorage.setItem("goodsword", JSON.stringify(goodsword));
};
let _getGoodsword = function() {
  let goodsword = [];
  goodsword = JSON.parse(localStorage.getItem("goodsword"));
  return goodsword;
};
let _saveStoreword = function(storeword) {
  localStorage.setItem("storeword", JSON.stringify(storeword));
};
let _getStoreword = function() {
  let storeword = [];
  storeword = JSON.parse(localStorage.getItem("storeword"));
  return storeword;
};
let _delGoodsword = function() {
  localStorage.removeItem("goodsword");
};
let _delStoresword = function() {
  localStorage.removeItem("storeword");
};
let _urlParse = function() {
  let obj = {};
  let reg = /[?&][^?&]+=[^?&%]+/g;
  let url = window.location.search;
  let arr = url.match(reg) || [];
  arr.forEach(item => {
    let tempArr = item.substring(1).split("=");
    let key = decodeURIComponent(tempArr[0]);
    let val = decodeURIComponent(tempArr[1]);
    obj[key] = val;
  });
  return obj;
};

let changePageHeader = function() {
  if (sourec.isFromApp) {
    document.getElementById("apptip").style.display = "none";
    if (document.getElementById("header")) {
      document.getElementById("header").style.display = "none";
      document.getElementById("h-content").style.cssText =
        "padding-top:0 !important;";
    }
  }
};
const patchUrl = (type, url) => {
  return CurrentEnvPrefix[type] + url;
};
function _addSpm(spm) {
  var params = { spm_code: spm };
  api.post({ api: "/ad/spm", param: params }).then(response => {});
}

var _common = {
  getSourec: function() {
    return sourec;
  },
  //	来自app的标识
  //是否APP过来，需隐藏头部
  setIsFromApp: function() {
    return appversion;
    // sfrom = GetQueryString('isfrom');
    // if (sfrom && sfrom!='null') { isFromApp = sfrom.length > 0; }
    // // 默认是隐藏头部的；如果是从app过来的就隐藏，反之显示
    // if (isFromApp) { $("#header").css("display","none"); $("#bottom").css("display","none"); }
    // else { $("#header").css("display","block"); $("#bottom").css("display","block"); }
  },
  setGoodsword: function(goodsword) {
    if (!goods) {
      goods = [];
    }
    goods.push(goodsword);
    _saveGoodsword(goods);
  },
  getGoodsword: function() {
    goods = _getGoodsword();
    return goods;
  },
  setStoreword: function(storeword) {
    if (!store) {
      store = [];
    }
    store.push(storeword);
    _saveStoreword(store);
  },
  getStoreword: function() {
    store = _getStoreword();
    return store;
  },
  delGoodsword: function() {
    goods = _delGoodsword();
    return goods;
  },
  delStoresword: function() {
    store = _delStoresword();
    return store;
  },
  urlParse: function() {
    param = _urlParse();
    return param;
  },
  init: function() {
    let params = _urlParse(); //所以分割出来的参数
    sourec.key = params.key;
    // sourec.isFromApp = true;
    sourec.isFromApp = params.isfrom ? true : false;
    var u = navigator.userAgent;
    changePageHeader();
    var u = navigator.userAgent;
    sourec.isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    sourec.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    // appversion =params.appversion;
    // if(key){
    // 	//通过key请求用信息
    // 	//存储用户信息
    // }
  },
  openApp: function(cb) {
    var href = "";
    //识别系统
    var u = navigator.userAgent;
    var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    var isChrome = window.navigator.userAgent.indexOf("Chrome") !== -1;
    if (isIos) {
      href = "appzhaojiafangcs://HomeZJFController";
    } else if (isAndroid) {
      href = "zhaojiafang://Home";
    }
    location.href = href;
    setTimeout(function() {
      location.href = "/common/downloadapp";
    }, 1000);
    setTimeout(function() {
      location.reload();
    }, 4000);
  },
  barHeight: function() {
    return _barHeight;
  },
  addSPM(spm) {
    _addSpm(spm);
  },
  getlinkToErpUrl(url, query, member_center) {
    const token = Cookies.get("erp_access_token");
    if (member_center) {
      return patchUrl("user", `${url}?token=${token + query}`);
    }
    return patchUrl("erp", `${url}?token=${token + query}`);
  }
};

export default _common;



// WEBPACK FOOTER //
// ./src/global/js/common.js